import React, { Component } from 'react'

export default class NotFound extends Component {
    render() {
        return (
            <div style={{display:'flex',height:'100vh',flexDirection:'column',justifyContent:'center',justifyItems:'center',alignItems:'center'}}>
                <div>صفحه مورد نظر پیدا نشد</div>
            </div>
        )
    }
}
